module.exports = __webpack_public_path__ + "static/media/turin-8.99201584.jpg";